import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { (async () => { const { data } = await api.get(`/blog/${slug}`); setPost(data); })(); }, [slug]);
  if (!post) return <div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-4 border-orange-500/30 border-t-orange-500 rounded-full animate-spin" /></div>;
  return (
    <main className="pt-28 pb-24">
      <article className="max-w-3xl mx-auto px-4">
        <p className="text-xs uppercase tracking-widest text-[#FF6B35] font-poppins font-semibold">{post.category}</p>
        <h1 className="mt-3 font-satoshi font-black text-4xl text-[#0A192F]">{post.title}</h1>
        <p className="mt-2 text-slate-500 font-inter">{post.author} · {post.date}</p>
        <img src={post.image} alt={post.title} className="mt-8 rounded-3xl w-full h-80 object-cover" />
        <div className="mt-8 prose prose-slate font-inter text-slate-700 leading-relaxed">
          <p>{post.content}</p>
        </div>
        <Link to="/blog" className="mt-10 inline-block ali-btn-outline">← All Posts</Link>
      </article>
    </main>
  );
}
